/* GRD Shopify Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // ── AGE GATE ──
  const gate = document.getElementById('age-gate');
  const denied = document.getElementById('age-denied');
  if (gate) {
    if (!sessionStorage.getItem('grd_age_ok')) {
      gate.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    document.getElementById('age-yes')?.addEventListener('click', function () {
      sessionStorage.setItem('grd_age_ok', '1');
      gate.style.opacity = '0';
      gate.style.transition = 'opacity 0.4s';
      setTimeout(() => { gate.style.display = 'none'; document.body.style.overflow = ''; }, 400);
    });
    document.getElementById('age-no')?.addEventListener('click', function () {
      gate.style.display = 'none';
      if (denied) { denied.style.display = 'flex'; }
    });
  }

  // ── NAV SCROLL ──
  const nav = document.getElementById('main-nav');
  if (nav) {
    function updateNav() {
      if (window.scrollY > 40) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    }
    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }

  // ── MOBILE BURGER ──
  const burger = document.getElementById('nav-burger');
  const drawer = document.getElementById('nav-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('open');
      drawer.classList.toggle('open');
      document.body.classList.toggle('no-scroll');
    });
  }

  // ── REVEAL ON SCROLL ──
  function initReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const delay = parseFloat(e.target.dataset.delay || 0) * 1000;
          setTimeout(() => e.target.classList.add('visible'), delay);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => io.observe(el));
  }
  initReveal();

  // ── PRODUCT IMAGE THUMBNAILS ──
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-main-img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function () {
        mainImg.src = this.src.replace('_72x72', '_600x600');
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // ── TOAST ──
  window.GRD = {
    showToast: function (msg) {
      let toast = document.querySelector('.grd-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'grd-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 3000);
    }
  };

  // ── ADD TO CART (AJAX) ──
  const atcBtn = document.querySelector('.add-to-cart-btn');
  const variantSelect = document.querySelector('.variant-select');
  if (atcBtn) {
    atcBtn.addEventListener('click', async function () {
      const variantId = variantSelect ? variantSelect.value : atcBtn.dataset.variantId;
      if (!variantId) return;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const data = await res.json();
        if (data.id) {
          GRD.showToast('✓ Added to cart');
          // Update cart count in nav
          const countEl = document.querySelector('.cart-count');
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          if (countEl) {
            countEl.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            const icon = document.querySelector('.nav-cart-icon');
            if (icon) {
              const span = document.createElement('span');
              span.className = 'cart-count';
              span.textContent = cart.item_count;
              icon.appendChild(span);
            }
          }
        }
      } catch (e) {
        GRD.showToast('Error — please try again');
      } finally {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      }
    });
  }

  // ── VARIANT PRICE UPDATE ──
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selected = this.options[this.selectedIndex];
      const price = selected.dataset.price;
      const priceEl = document.querySelector('.product-info-price');
      if (priceEl && price) {
        priceEl.textContent = '$' + (parseInt(price) / 100).toFixed(2);
      }
    });
  }

});
